import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { AnimalService } from './services/animal.service';

const MAX_SEARCH_RESULTS = 50;

@Component({
    selector: 'animal-placeholder-multiselect',
    template: `
<!-- Selected AnimalPlaceholders -->
<div *ngIf="model && model.length > 0">
    <table class="table table-sm table-borderless table-nonfluid">
        <tbody>
            <tr *ngFor="let item of model; let i = index;">
                <td class="icon-cell">
                    <a (click)="removeAnimalPlaceholder(i)" title="Remove Placeholder">
                        <i class="fa fa-remove remove-item"></i>
                    </a>
                </td>
                <td>
                    {{item.Name}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- AnimalPlaceholder typeahead -->
<climb-indirect-typeahead
        [search]="searchAnimalPlaceholders"
        [resultFormatter]="animalPlaceholderFormatter"
        placeholder="Name&hellip;"
        (selectItem)="selectAnimalPlaceholder($event)"></climb-indirect-typeahead>
`,
    styles: [`
        .table {
            margin-bottom: 0.25em;
        }
    `]
})
export class AnimalPlaceholderMultiselectComponent {
    @Input() model: any[];
    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private animalService: AnimalService
    ) { }

    removeAnimalPlaceholder(index: number) {
        if (this.model && index >= 0 && index < this.model.length) {
            this.model.splice(index, 1);
        }
        this.modelChange.emit(this.model);
    }

    searchAnimalPlaceholders = (term: string): Promise<any> => {
        return this.animalService.getAnimalPlaceholders({
            page: 1,
            size: MAX_SEARCH_RESULTS,
            sort: 'Name asc',
            filter: {
                name: term
            }
        }).then((results: any) => {
            // Convert Breeze entity to simple object
            // so it can be serialized by consumers
            return results.results.map((placeholder: any) => ({
                C_AnimalPlaceholder_key: placeholder.C_AnimalPlaceholder_key,
                Name: placeholder.Name
            }));
        });
    }

    animalPlaceholderFormatter = (value: any) => {
        return value.Name;
    }

    selectAnimalPlaceholder(placeholder: any) {
        if (this.model) {
            this.model.push(placeholder);
        } else {
            this.model = [placeholder];
        }

        this.modelChange.emit(this.model);
    }
}
